module.exports = __webpack_public_path__ + "static/media/let-pagination.1db80f90.svg";